import * as React from 'react';

interface CardProps {
  color?: string;
  header: string;
  imgSrc?: string;
  imgAlt?: string;
  onClick: (event: any) => void;
  text: string;
}

export class Card extends React.Component<CardProps, {}> {

  render() {
    const { imgSrc, imgAlt, onClick, header, text, color, mode } = this.props
    const img = imgSrc ? <img alt={imgAlt} src={imgSrc} /> : null
    return (
      <button className={`quill-card focus-on-light ${color ? color : ''}`} onClick={onClick}>
        {img}
        <div className="text">
          <h3>{header}</h3>
          <p>{text}</p>
        </div>
      </button>
    )
  }
}
